import { createReducer, on } from "@ngrx/store";
import { produce } from "immer";
import { GeneralState } from "../../models/state/app-state";
import { GeneralStateAction } from "./page-state.actions";

export const initialState: GeneralState = {
  loadSessionFromUserData: true,
  activeTableId: "",
  sharedPage: null,
  activeInstallation: null, // TODO: Use Installation refcode instead
  activeInstallationGroup: null, // TODO:  Use Installation refcode instead
  redirectUrl: null,
  showInstallationMenu: false,
  showInstallationMenuTopGroup: true,
  sidebarExpanded: true,
  shareAvalible: false,
  unShareAvalible: false,
  showSiteSearch: false,
  showRedirectScreen: false
}

export const generalStateReducere = createReducer(
  initialState,
  on(GeneralStateAction.setLoadSessionFromUserDataState, (state, newState) => {
    let oldstate = { ...state }

    return produce(oldstate, draft => {
      draft.loadSessionFromUserData = newState.loadSessionFromUser;
    });
  }),
  on(GeneralStateAction.setActiveTableIdState, (state, newState) => {
    let oldstate = { ...state }

    return produce(oldstate, draft => {
      draft.activeTableId = newState.tableId;
    });
  }),
  // on(GeneralStateAction.setSharedPageState, (state, newState) => {
  //   let oldstate = { ...state }

  //   return produce(oldstate, draft => {
  //     draft.sharedPage = newState.pageId;
  //   });
  // }),
  // on(GeneralStateAction.setActiveInstallationState, (state, action) => ({
  //   ...state,
  //   activeInstallation: action.installationId,
  //   redirectUrl: action.redirectUrl != undefined ? action.redirectUrl : null

  // })),
  on(GeneralStateAction.setRedirectUrlState, (state, action) => ({
    ...state,
    redirectUrl: action.redirectUrl != undefined ? action.redirectUrl : null
  })),
  on(GeneralStateAction.setShowInstallationMenu, (state, action) => ({
    ...state,
    showInstallationMenu: action.showInstallationMenu
  })),
    on(GeneralStateAction.setShowInstallationMenuTopGroup, (state, action) => ({
    ...state,
    showInstallationMenuTopGroup: action.showInstallationMenuTopGroup
  })),
  on(GeneralStateAction.toggleInstallationMenu, (state) => ({
    ...state,
    showInstallationMenu: !state.showInstallationMenu
  })),
  on(GeneralStateAction.setSidebarExpanded, (state, action) => ({
    ...state,
    sidebarExpanded: action.sidebarExpanded
  })),
  on(GeneralStateAction.toggleSidebarExpanded, (state) => ({
    ...state,
    sidebarExpanded: !state.sidebarExpanded
  })),
  on(GeneralStateAction.setShareAvalibleState, (state, action) => {


    const nextState = produce(state, draft => {
      draft.shareAvalible = action.shareState;
      draft.unShareAvalible = false;
    })

    return {
      ...state,
      ...nextState
    }
  }),
  on(GeneralStateAction.setUnShareAvalibleState, (state, action) => ({
    ...state,
    unShareAvalible: action.unShareState
  })),
  on(GeneralStateAction.setShowSiteSearchState, (state, action) => ({
    ...state,
    showSiteSearch: action.showSiteSearch
  })),
    on(GeneralStateAction.setShowRedirectScreenState, (state, action) => ({
    ...state,
    showRedirectScreen: action.showRedirectScreen
  })),
)

